<template>
  <b-modal
    ref="modal"
    title="Thanh toán phần dư"
    centered
    cancel-variant="outline-secondary"
    @ok.prevent="handlePaymentBalance"
    :ok-disabled="loading || submitting"
  >
    <span> Bạn chắc chắn muốn thành toán số dư còn lại?</span>
    <template #modal-cancel>
      <span>Từ chối</span>
    </template>
    <template #modal-ok>
      <Spinner v-if="loading" />
      <span v-else>Chấp nhận</span>
    </template>
  </b-modal>
</template>

<script>
import { functionProp } from "@/helpers/props";
import useToastHandler from "@/services/toastHandler";
import Spinner from "@core/components/Spinner";
import { BButton, BCol, BFormTextarea, BRow, VBModal } from "bootstrap-vue";

import { mapActions, mapState } from "vuex";

export default {
  components: {
    BButton,
    BCol,
    BRow,
    VBModal,
    Spinner,
    BFormTextarea,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    handleUpdateInformation: functionProp(),
  },
  data() {
    return {
      discount: null,
      submitting: false,
    };
  },
  computed: {
    ...mapState({
      loading: (s) => s.apps.users.paymentBalance.loading,
    }),
  },
  methods: {
    ...mapActions({
      paymentBalance: "users/paymentBalance/paymentBalance",
    }),
    async handlePaymentBalance() {
      if (this.submitting) return;
      this.submitting = true;
      try {
        const { userId } = this.$router.currentRoute.params;
        if (!userId) {
          this.showToastError("Không tìm thấy thông tin người dùng.");
          return;
        }

        const res = await this.paymentBalance({
          userId: Number(userId),
        });
        if (res) {
          /* Update user detail*/
          this.handleUpdateInformation({
            balance: res.balance ?? 0,
          });
          this.showToastSuccess(null, "Thanh toán phần dư thành công.");
        }
        this.$refs.modal.hide();
      } finally {
        this.submitting = false;
      }
    },
    handleShowModal() {
      this.$refs.modal.show();
    },
  },
  setup() {
    return {
      ...useToastHandler(),
    };
  },
};
</script>
